
import React from "react"
import { FormulaElement, MediaElement, CheckElement, DateTimeElement, DurationElement, ElementBase, GeoElement, MultipleElement, NumberElement, QrElement, TextElement, TimestampElement, TitleElement, GroupElement, SimpleListElement, PopulateElement, SignatureElement, ValidateElement } from "."
import { View,StyleSheet, Text } from "react-native";




export const FieldsList = ({ elementsTemplate, horizonalView, scroll, itemsStore, fields, parentId = undefined, forReview = false, recordIdx = undefined, statusStore, setItemRef }) => {

    console.log("FieldsList", "parentId", parentId)
    const payload = itemsStore.itemActive.payload;
   

    const ComponentMap = {
        time: DateTimeElement,
        date: DateTimeElement,
        duration: DurationElement,
        checkbox: CheckElement,
        select: MultipleElement,
        multiple: MultipleElement,
        timestamp: TimestampElement,
        geo: GeoElement,
        text: TextElement,
        qr: QrElement,
        docs: MediaElement,
        video: MediaElement,
        photo: MediaElement,
        number: NumberElement,
        formula: FormulaElement,
        group: GroupElement,
        simplelist: SimpleListElement,
        title: TitleElement,
        populate: PopulateElement,
        validate: ValidateElement,
        sign: SignatureElement,
    };
   
    const elementsStructurals = ['checkbox', 'group', 'simplelist', 'title'];
    const renderField = (field: any, pId: string|undefined = undefined, rIdx = undefined, rowWidth) => {
        if (field.isArchived) return null;
        const isStructural = elementsStructurals.includes(field.type);
        const payloadElement = payload.get(field.id);
        const hasValue = payloadElement && JSON.stringify(payloadElement.value) !== "" && payloadElement.value != null;
         const isReviewMode = forReview === true  ;
         if(field.id=="30kunvt9t"){
console.log("FieldList", "field", field);
         }
            
        if (isReviewMode && !isStructural && !hasValue) return null;

        const fieldType = field.type == "sendemail" ? (field.templateData.asSelect ? "select" : "text") : field.type;
       // field.name = "ig:".concat(payloadElement?.inactiveGroup," ro",payloadElement?.readOnly," |" ,field.id)
        const commonProps = {
            parentId: pId,
            element: field,
            forReview: isReviewMode,
            recordIdx: rIdx,
            elementsTemplate,
            key: `${field.type}-${field.id}-${rIdx}`
        };
        const SelectedComponent = ComponentMap[fieldType] || ElementBase;
        let content = null;
        switch (fieldType) {
            case 'checkbox':
                content = <CheckElement setItemRef={setItemRef}  {...commonProps} />
                break;
            case 'group':
                content = field.nodes?.length > 0 ? (<GroupElement {...commonProps} >
                    {
                        putFields(field.nodes, pId, recordIdx)
                    }
                </GroupElement>) : <></>;
                break;
            case 'simplelist':
                let autonumeric = field.nodes.find(f => f.type == "autonumeric");
                if (autonumeric != undefined) {
                    autonumeric.type = "formula";
                    autonumeric.templateData.hidden = false;
                    autonumeric.templateData.formula = { formula: "i", variables: [{ variable: "i", dataSource: { id: "{index}" } }] }
                }
                content = field.nodes?.length > 0 ? (<SimpleListElement {...commonProps}>
                    <View style={styles.wrapContainer} key={commonProps.key.concat("_view")}>{
                            putFields(field.nodes, field.id, recordIdx,0)
                        }</View>
                </SimpleListElement>) : <></>;
                break;
            default:
                content = (<SelectedComponent {...commonProps} />);

        }

        const isWideScreen = statusStore.windowDimensions.width > 1000;
        const fieldWidth = (field.templateData?.width && isWideScreen) 
            ? field.templateData.width 
            : "100%";
        rowWidth += Number(fieldWidth.replace("%",""));
        let newRow= false;
        if(rowWidth>100){
            rowWidth=0;
            newRow=true;
        }
        return (
            <><View key={"new_row_" + field.id + rIdx} style={{ width:(newRow ? "100%" : 0), height: (newRow ? 1 : 0)}}></View><View 
                key={"view_fld_" + field.id + rIdx}
                style={[
                    styles.fieldWrapper, 
                    { width: fieldWidth, backgroundColor: field.templateData?.backgroundColor || "#fff" , borderTopWidth: field.templateData?.hidden?0:1},
                    fieldType === "group" && styles.noBorderTop
                ]}
            >
               {content}
            </View></>
        );
    }
//"checkbox","group","title","select","formula","number","sign","simplelist", {["text"].includes(fieldType) ?content: (<View><Text>{fieldType}</Text></View>)}

    const putFields = (fields: any[], parentId: string = undefined, recordIdx = undefined, rowWidth=0) => {
        return fields?.map((field: any, idx: number) => {
            return renderField(field, parentId, recordIdx,rowWidth);

        });
    }

        return <View style={styles.wrapContainer} key={"wrapContainer_"+parentId+recordIdx}>{putFields(fields, parentId, recordIdx,0)}</View>;

   
};

const styles = StyleSheet.create({
    wrapContainer: {
        flexDirection: 'row',flexWrap: 'wrap',
        //flexDirection: Platform.OS !== 'web' ? 'column' : 'row',
        //flexWrap:  Platform.OS == 'web' ? 'wrap':undefined,
        padding: 2,
        width: "100%", 
        marginTop: "auto", backgroundColor:"#fff"
    },
    fieldWrapper: {
        minWidth: 150,
        
        borderTopColor: "#ccc",
        flexWrap: "wrap",
    },
    noBorderTop: {
        borderTopWidth: 0,
    }
});